import type { IconProps } from './../../models/icon';

export function DownloadIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 48 48"
      className={className}
      width={width}
      height={height}
    >
      <path
        fill={secondaryColor}
        d="M39.4284 16.2857C39.883 16.2857 40.3191 16.4663 40.6407 16.7878C40.962 17.1093 41.1426 17.5453 41.1426 18V43.7143C41.1426 44.1689 40.962 44.605 40.6407 44.9266C40.3191 45.2479 39.883 45.4286 39.4284 45.4286H8.57122C8.11656 45.4286 7.68051 45.2479 7.35905 44.9266C7.03755 44.605 6.85693 44.1689 6.85693 43.7143V18C6.85693 17.5453 7.03755 17.1093 7.35905 16.7878C7.68051 16.4663 8.11656 16.2857 8.57122 16.2857H39.4284Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.4"
        d="M35.9998 16.2857H39.4284C39.883 16.2857 40.3191 16.4663 40.6407 16.7878C40.962 17.1093 41.1426 17.5453 41.1426 18V43.7143C41.1426 44.1689 40.962 44.605 40.6407 44.9266C40.3191 45.2479 39.883 45.4286 39.4284 45.4286H8.57122C8.11656 45.4286 7.68051 45.2479 7.35905 44.9266C7.03755 44.605 6.85693 44.1689 6.85693 43.7143V18C6.85693 17.5453 7.03755 17.1093 7.35905 16.7878C7.68051 16.4663 8.11656 16.2857 8.57122 16.2857H11.9998"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.4"
        d="M23.9998 2.57141V30"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.4"
        d="M17.1426 23.1429L23.9997 30L30.8569 23.1429"
      />
    </svg>
  );
}
